<template>
  <div class="change-skin">
    <div class="skin-group">
      <div class="skin-group-list" :style="{ width: isExpanded ? '175px' : 'auto' }">
        <template v-for="(key, index) in Object.keys(dataSource)">
          <el-popover
            placement="top-start"
            trigger="hover"
            popper-class="skin-popover"
            :close-delay="0"
            :key="key"
            v-if="dataSource[key].cover.hasValue && dataSource[key].cover.value"
          >
            <!--hover界面-->
            <div class="popover-content" ref="popoverContainer">
              <div class="role-img">
                <img
                  :src="dataSource[key].cover.value"
                  :data-map-type="dataSource[key].cover.type"
                  :data-map-key="dataSource[key].cover.key"
                  class="skin-img"
                  alt=""
                />
              </div>
              <div class="skin-info">
                <div class="info-top">
                  <div
                    class="skin-type"
                    :data-map-type="dataSource[key].name.type"
                    :data-map-key="dataSource[key].name.key"
                    v-if="hasAccessValue(key)"
                  >
                    {{ dataSource[key].name.value }}
                  </div>
                  <div class="skin-name" v-if="hasAccessValue(key)">{{ dataSource[key].nameSeries.value }}</div>
                </div>
                <div
                  class="info-desc"
                  :data-map-type="dataSource[key].slogan.type"
                  :data-map-key="dataSource[key].slogan.key"
                >
                  {{ dataSource[key].slogan.value }}
                </div>
                <template v-if="hasAccessValue(key)">
                  <div class="get-methods">【获取方式】</div>
                  <div
                    class="get-methods-desc"
                    :data-map-type="dataSource[key].access.type"
                    :data-map-key="dataSource[key].access.key"
                  >
                    {{ dataSource[key].access.value }}
                  </div>
                </template>
              </div>
            </div>
            <!--展示界面-->
            <div
              class="skin-list-item"
              slot="reference"
              :class="{ active: activeSkin === index }"
              @click="switchSkin(key, index)"
            >
              <img
                :src="dataSource[key].cover.value"
                :data-map-type="dataSource[key].cover.type"
                :data-map-key="dataSource[key].cover.key"
                alt=""
              />
            </div>
          </el-popover>
        </template>
      </div>
    </div>
    <template v-if="skinLength > 4">
      <img
        v-if="isExpanded"
        src="@/assets/nikke_imgs/skin-unfoding-icon.png"
        alt=""
        class="skin-opt"
        @click="handleExpand"
      />
      <img v-else src="@/assets/nikke_imgs/skin-retracted-icon.png" alt="" class="skin-opt" @click="handleExpand" />
    </template>
  </div>
</template>
<script>
export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      activeSkin: 0,
      isExpanded: false,
      skinLength: 0
    };
  },
  watch: {
    dataSource: {
      handler() {
        this.skinLength = 0;
        Object.keys(this.dataSource).forEach(key => {
          if (this.dataSource[key].cover.hasValue && this.dataSource[key].cover.value) {
            this.skinLength++;
          }
        });
      }
    }
  },

  methods: {
    handleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    switchSkin(key, index) {
      this.activeSkin = index;
      this.$emit("switchSkin", key, index);
      this.$emit("switchSkin", key);
    },
    hasAccessValue(key) {
      return Boolean(this.dataSource[key]?.access?.value) && this.dataSource[key].access.value.trim() !== "/";
    }
  }
};
</script>

<style scoped lang="less">
.change-skin {
  position: absolute;
  bottom: 32px;
  left: 180px;
  z-index: 1000;

  .skin-group {
    height: 105px;
    overflow: hidden;
    .skin-group-list {
      width: 100%;
      height: 100%;
      display: flex;
      flex-wrap: nowrap;
      align-items: flex-end;
      column-gap: 10px;
      transition: width 0.3s ease-in-out;

      .skin-list-item {
        position: relative;
        width: 47px;
        height: 84px;
        background: url("~@/assets/nikke_imgs/skin-bg.png") no-repeat;
        background-size: 100% 100%;
        transition: all 0.1s ease-in-out;
        flex-shrink: 0;

        &:after {
          content: "";
          display: inline-block;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.25);
          transition: all 0.1s ease-in-out;
        }

        &.active {
          width: 55px;
          height: 100px;

          &:after {
            display: none;
            transition: all 0.1s ease-in-out;
          }
        }

        img {
          position: relative;
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .skin-opt {
    position: absolute;
    right: -16px;
    top: 0;
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
}
</style>
<style lang="less">
.skin-popover {
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.4);
  border-radius: 4px 4px 4px 4px;
  padding: 5px;

  .popover-content {
    width: 337px;
    min-height: 110px;
    display: flex;
    justify-content: space-between;
    column-gap: 7px;

    .role-img {
      position: relative;
      width: 74px;
      height: 109px;
      background: url("~@/assets/nikke_imgs/skin-map-bg.png") no-repeat;
      background-size: 100% 100%;

      .skin-img {
        position: absolute;
        width: 68px;
        height: 100px;
        bottom: 0;
        right: 0;
        object-fit: cover;
      }
    }

    .skin-info {
      flex: 1;

      .info-top {
        font-family: Source Han Sans CN, Source Han Sans CN;
        width: 100%;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .skin-type {
          height: 100%;
          display: flex;
          align-items: center;
          font-weight: 500;
          font-size: 14px;
          color: #142630;
        }

        .skin-name {
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 72px;
          height: 22px;
          background: #414f6c;
          border-radius: 2px;
        }
      }

      .info-desc {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
        color: #142630;
        margin: 8px 0;
      }

      .get-methods {
        height: 24px;
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        font-weight: 500;
        font-size: 13px;
        color: #142630;
      }

      .get-methods-desc {
        font-weight: 400;
        font-size: 12px;
        color: #142630;
        line-height: 16px;
      }
    }
  }
}
</style>
